module.exports = __webpack_public_path__ + "media/packs/images/soc_icons-c3767e3f207672ce8b05ef9be6660496.png";